/**
 * feedSorting
 *
 * The ordering the project's feed list can be read in: what the two sortable
 * headers cycle through, and which direction each key reads in when it is first
 * clicked.
 *
 * The natural direction is the direction the question is asked in, which is why it
 * is not simply "ascending": "last change" is asked to find what moved recently and
 * "percentile" to find the busiest calendars, so both start at their top end. The
 * listing's own default — creation order — is a separate thing, restored by
 * clearing the sort rather than by a third click.
 */

/** DEFAULT_SORT is the order a freshly opened project is listed in. */
export const DEFAULT_SORT = { key: "created", order: "asc" };

/** naturalOrder is the direction a key is first clicked into. */
export function naturalOrder(key) {
  return key === "created" ? "asc" : "desc";
}

/**
 * nextSort keeps the header's behaviour in one testable place: a new column starts
 * at its natural direction, and clicking the active one flips it. Without the flip
 * a reader who wants the quietest calendars first has no way to ask.
 */
export function nextSort(current, key) {
  if (current?.key !== key) return { key, order: naturalOrder(key) };
  return { key, order: current.order === "asc" ? "desc" : "asc" };
}

/**
 * sortParams turns the component's sort into query parameters, omitting the
 * listing's default so a screen that has not been sorted does not ask the server
 * for the ordering it would have used anyway.
 */
export function sortParams(sort) {
  if (!sort || sort.key === DEFAULT_SORT.key) return {};
  return { sort: sort.key, order: sort.order };
}

/**
 * sortLabel describes the current ordering, so the toolbar can say what the list
 * has been sorted by — and offer the way back to the default.
 */
export function sortLabel(sort) {
  if (!sort || sort.key === DEFAULT_SORT.key) return "";
  if (sort.key === "percentile") {
    return sort.order === "asc" ? "percentile (quietest first)" : "percentile (busiest first)";
  }
  return sort.order === "asc" ? "last change (oldest first)" : "last change (newest first)";
}
